<div class="access-suspended">
  <div class="access-suspended__card">
    <terra-icon class="access-suspended__icon" icon="lock" variant="duotone" size="48" />

    <h1 class="terra-h2">Access Suspended</h1>

    <p class="terra-body">
      Company access is suspended. Contact
      <a href="mailto:helpful@ninety.io">helpful&#64;ninety.io</a>
      for more details on how to resume account access.
    </p>

    @if (otherCompanies$ | async; as otherCompanies) {
      @if (otherCompanies.length) {
        <div class="access-suspended__switch">
          <p class="terra-body-bold">Switch to another company</p>
          @for (company of otherCompanies; track company.companyId) {
            <ninety-button stroked (click)="switchCompany(company)">{{ company.companyName }}</ninety-button>
          }
        </div>
      }
    }

    <ninety-button flat primary (click)="signOut()">Sign Out</ninety-button>
  </div>
</div>
